var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { padding: "5px 0 5px 10px" } }, [
    _c("div", { staticClass: "flex" }, [
      _c("div", { staticClass: "vTitle" }, [_vm._t("default")], 2),
      _c("img", {
        staticClass: "titleIs",
        attrs: { src: require("images/index/home/title-line.png"), alt: "" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }